import createIcon from '../../createIcon';

/**
 * @component @name Http
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDExSDIuNVY5SDFWMTVIMi41VjEyLjVINC41VjE1SDZWOUg0LjVWMTFaTTcgMTAuNUg4LjVWMTVIMTBWMTAuNUgxMS41VjlIN1YxMC41Wk0xMi41IDEwLjVIMTRWMTVIMTUuNVYxMC41SDE3VjlIMTIuNVYxMC41Wk0yMS41IDlIMThWMTVIMTkuNVYxM0gyMS41QzIyLjMgMTMgMjMgMTIuMyAyMyAxMS41VjEwLjVDMjMgOS43IDIyLjMgOSAyMS41IDlaTTIxLjUgMTEuNUgxOS41VjEwLjVIMjEuNVYxMS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Http = createIcon('Http', [
  [
    'path',
    {
      d: 'M4.5 11H2.5V9H1V15H2.5V12.5H4.5V15H6V9H4.5V11ZM7 10.5H8.5V15H10V10.5H11.5V9H7V10.5ZM12.5 10.5H14V15H15.5V10.5H17V9H12.5V10.5ZM21.5 9H18V15H19.5V13H21.5C22.3 13 23 12.3 23 11.5V10.5C23 9.7 22.3 9 21.5 9ZM21.5 11.5H19.5V10.5H21.5V11.5Z',
      key: '14onjr',
    },
  ],
]);

export default Http;
